import React, { useState, useEffect } from 'react';
import { Clock, Check } from 'lucide-react';

const BenefitCard = ({ benefit, onTimerComplete, timerComplete }) => {
  const [timeLeft, setTimeLeft] = useState(3);

  useEffect(() => {
    setTimeLeft(3);
  }, [benefit.id]);

  useEffect(() => {
    if (timeLeft > 0 && !timerComplete) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    } else if (timeLeft === 0 && !timerComplete) {
      onTimerComplete();
    }
  }, [timeLeft, timerComplete, onTimerComplete]);

  return (
    <>
      <div className="text-center mb-8">
        <div className="text-6xl mb-4 animate-bounce">
          {benefit.icon}
        </div>
        <h2 className="text-2xl font-bold text-white mb-4">
          Beneficio {benefit.id}
        </h2>
        <h3 className="text-xl font-semibold text-yellow-500 mb-4">
          {benefit.title}
        </h3>
        <p className="text-gray-300 leading-relaxed">
          {benefit.description}
        </p>
      </div>

      {!timerComplete && timeLeft > 0 && (
        <div className="flex flex-col items-center justify-center mb-8">
          <div className="flex items-center gap-2 text-gray-400">
            <Clock className="w-5 h-5" />
            <span>Conoce este beneficio...</span>
          </div>
          <div className="mt-4 w-12 h-12 rounded-full border-4 border-yellow-500 flex items-center justify-center">
            <span className="text-xl font-bold text-yellow-500">{timeLeft}</span>
          </div>
        </div>
      )}

      {timerComplete && (
        <div className="flex items-center justify-center mb-8">
          <div className="flex items-center gap-2 text-green-400">
            <Check className="w-5 h-5" />
            <span>Beneficio revisado</span>
          </div>
        </div>
      )}
    </>
  );
};

export default BenefitCard;